import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
  payouts: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
  filters: {
    page: 1,
    limit: 10,
    search: "",
    mandateType: "",
    status: "",

    startDate: null,
    endDate: null,
  },
};

const payoutSlice = createSlice({
  name: "payouts",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPayouts: (state, action) => {
      state.payouts = action.payload.payouts;
      state.pagination = action.payload.pagination;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setLoading, setPayouts, setError, setFilter, resetFilters } =
  payoutSlice.actions;

export const fetchPayouts = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const { filters } = getState().payouts;

    const params = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axiosInstance.get("/loan/loans/payout", { params });
    dispatch(setPayouts(response.data.data));
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export default payoutSlice.reducer;
